module.exports = __webpack_public_path__ + "static/media/Colette Single Bed Base - 90x200 cm_Dark Blue.4b724f8e.png";